export const CART_UPDATE_REQUESTED = 'CART_UPDATE_REQUESTED';
export const CART_UPDATE_SUCCEEDED = 'CART_UPDATE_SUCCEEDED';
export const CART_SNAPSHOT_SYNC_REQUESTED = 'CART_SNAPSHOT_SYNC_REQUESTED';
export const CART_SNAPSHOT_SYNC_PENDING = 'CART_SNAPSHOT_SYNC_PENDING';
export const CART_SNAPSHOT_CLEAR_REQUESTED = 'CART_SNAPSHOT_CLEAR_REQUESTED';

export const CART_CHECKOUT_PICKUP_REQUESTED = 'CART_CHECKOUT_PICKUP_REQUESTED';
export const CART_CHECKOUT_DELIVERY_REQUESTED = 'CART_CHECKOUT_DELIVERY_REQUESTED';
export const CART_CHECKOUT_SUCCEEDED = 'CART_CHECKOUT_SUCCEEDED';
export const CART_CHECKOUT_FAILED = 'CART_CHECKOUT_FAILED';

export const CART_COUPON_REQUESTED = 'CART_COUPON_REQUESTED';
export const CART_COUPON_SUCCEEDED = 'CART_COUPON_SUCCEEDED';
export const CART_COUPON_FAILED = 'CART_COUPON_FAILED';

export const CART_COUPON_DELETE = 'CART_COUPON_DELETE';

export const CART_GET_PRODUCTS_REQUESTED = 'CART_GET_PRODUCTS_REQUESTED';
export const CART_GET_PRODUCTS_SUCCEEDED = 'CART_GET_PRODUCTS_SUCCEEDED';
export const CART_GET_PRODUCTS_FAILED = 'CART_GET_PRODUCTS_FAILED';
